import { HTMLAttributes, PropsWithChildren } from 'react';
import cn from 'classnames';
import style from './TestimonialJob.module.scss';
import { PropsWithTestId } from '../../../../../../../types';

export type TestimonialJobProps = PropsWithTestId<
  PropsWithChildren<HTMLAttributes<HTMLElement>>
>;

export const TestimonialJob = (props: TestimonialJobProps) => {
  const { className, children, testId, ...restProps } = props;
  return (
    <p
      {...restProps}
      data-testid={testId}
      className={cn(style.paragraph, className)}
    >
      {children}
    </p>
  );
};

TestimonialJob.defaultProps = {
  testId: 'testimonial-job',
};
